// test2302
(2302 && 0);
